import React, { useContext, useEffect, useRef, useState } from 'react';
import AppContext from '../../../App/AppContext';
import { CircularProgress, FormHelperText, FormLabel, Grid, IconButton, InputLabel, Tooltip } from '@material-ui/core';
import { SecondaryButton, TextBox } from '../../../Core/FormInput';
import { CustomeSignPad } from '../../../Core/SignaturePad';
import { Backup } from '@material-ui/icons';
import getResizedImage from '../../../Core/CommonFunctions/imageResizer';
import CloseIcon from '@material-ui/icons/Close';
import { getBrakeTest_GetDetails, postBreakTestDetails } from '../../../Core/Service/breakTest';
import { getDocumentByName } from '../../../Core/Service/workflowJobDocument-service';
import doc from '../../internal/workflow-job/doc.png'; //'../../internal/workflow-job/doc.png';
import { ArrowLeft, ArrowRight, History, Image } from '@material-ui/icons';
import SingleDocumentViewer from '../../../Core/FileUploader/DocumentViewer';
import { AppStorage } from '../../../Core/Service/storage-service';
import ViewPdfModal from '../../../Core/Modal/PdfViweModal';
import moment from 'moment';
import formatters from '../../../Core/Grid/inputFormatter';

let styles = {
    required: {
        color: 'red',
        fontSize: 13,
        float: 'left'
    }
};

const BreakTest = (props) => {
    const { hideModal, showToast, hideTopNavAndMenu, userRoles, displayName } = useContext(AppContext);
    const isAuditor = userRoles.includes('auditor');
    const urlParams = new URLSearchParams(props?.location?.search.toLowerCase());
    const navigateToDashboard = urlParams.get('navigate') === 'true';
    const fromStep = urlParams.get('fromstep') === 'true';
    const signCanvas = useRef({});
    const signteamleaderCanvas = useRef({});
    const Id = props?.match?.params?.jobId || props.HeaderRecordID || null;
    const portalSettings = AppStorage.getPortalSetting();
    const [btnLoader, setBtnLoader] = useState(false);

    const [state, setState] = useState({
        errors: {},
        showCircularLoader: true,
        showImageCircularLoader: true,
        list: [],
        imagesFromUrl: [],
        hasLocalFile: true,
        brakeTestSignedName: '',
        brakeTestSigned: false
    });

    const [documentLoader, setDocumentLoader] = useState(true);
    const [currentPageNo, setPageNo] = useState(0);
    const [error, setError] = useState({});

    useEffect(async () => {
        let res = await getBrakeTest_GetDetails(Id);

        if (res) {
            let data = res.data.breakTest[0] || {};
            setState((st) => ({
                ...st,
                registration: data.registration || '',
                wipNumber: data.wipNumber || '',
                brakeTestDeclaration: data.brakeTestDeclaration || '',
                brakeSignature: data.brakeTestSignature || '',
                brakeTestSignature: data.brakeTestSignature || '',
                brakeTestSigned: data.brakeTestSigned || '',
                brakeTestSignedDate: data.brakeTestSignedDate || '',
                brakeTestSignedName: data.brakeTestSignedName || displayName || '',
                brakeTestJobDocumentName: data.brakeTestJobDocumentName || '',
                brakeTestSignedUserID: data.brakeTestSignedUserID || '',
                emailsentTo: data.emailsentTo || '',
                sendEmail: data.sendEmail || '',
                createDocument: data.brakeTestJobDocumentName ? false : true || '',
                showCircularLoader: false
            }));
            setState((st) => ({ ...st, showCircularLoader: false }));
        }
    }, []);

    useEffect(async () => {
        if (state.brakeTestJobDocumentName) {
            pullDocumentsAndUpdateState(1);
        } else {
            setState((st) => ({
                ...st,
                imagesFromUrl: [],
                hasLocalFile: false
                // showImageCircularLoader: false
            }));
            setDocumentLoader(false);
        }
    }, [state.brakeTestJobDocumentName]);

    const pullDocumentsAndUpdateState = async (docCount) => {
        setDocumentLoader(true);

        const res = await getDocumentByName(state.brakeTestJobDocumentName, docCount);
        let docHasNext = res.hasMorePage;
        setState((st) => {
            const imagesFromUrl = [...st.imagesFromUrl];
            imagesFromUrl.push(res.imgBase64Src);
            return {
                ...st,
                imagesFromUrl,
                hasLocalFile: false
            };
        });

        if (docHasNext) {
            pullDocumentsAndUpdateState(docCount + 1);
        } else {
            setDocumentLoader(false);
        }
    };

    const handleFieldChange = (e) => {
        const { name, value, checked, type } = e.target;

        if (type == 'checkbox') {
            setState((st) => ({ ...st, [name]: checked }));
        } else {
            setState((st) => ({ ...st, [name]: value }));
        }
    };

    const GetTechnicianSign = (val) => {
        setState((st) => ({
            ...st,
            ...val
        }));
    };

    const clearSig = (val) => {
        setState((st) => ({
            ...st,
            brakeTestSignature: null,
            brakeSignature: null
        }));
    };

    const hasPrev = (pageNo) => {
        return pageNo > 0;
    };

    const hasNext = (pageNo) => {
        let total = state.imagesFromUrl.length;
        return pageNo < total - 1;
    };

    const handleImage = (e) => {
        const file = e.target.files?.[0];
        // console.log('file', file);

        if (file && file.type === 'application/pdf') {
            setState((st) => ({
                ...st,
                imagesFromUrl: file,
                selectedFileExt: file.name.split('.').pop(),
                createDocument: true,
                hasLocalFile: true
            }));
        } else {
            alert('Please select a valid PDF file.');
        }
    };
    const handleRemoveImage = () => {
        setState((st) => ({
            ...st,
            imagesFromUrl: [],
            selectedFileExt: '',
            createDocument: false,
            hasLocalFile: false
        }));
    };

    const validation = () => {
        let isValid = true;
        let error = {};

        const { brakeTestSignature, brakeTestSignedName } = state;

        if (!brakeTestSignature) {
            error['brakeTestSignature'] = 'Signature is required';
            isValid = false;
        }
        if (!brakeTestSignedName) {
            error['brakeTestSignedName'] = 'Name is required';
            isValid = false;
        }
        setError(error);
        return isValid;
    };

    const saveDynamicFormFieldUploadDoc = async () => {
        if (validation()) {
            setBtnLoader(true);

            const formData = new FormData();

            formData.append(state.imagesFromUrl?.name || '', state.imagesFromUrl || ''); // Note: the key "files" here matches how backend reads Request.Form.Files
            formData.append('brakeTestHeaderRecordID', Id || '');
            formData.append('brakeTestDeclaration', state.brakeTestDeclaration || '');
            formData.append('brakeTestSignature', state.brakeTestSignature || '');
            formData.append('brakeTestSignedName', state.brakeTestSignedName || '');
            formData.append('emailsentTo', state.emailsentTo || '');
            formData.append('sendEmail', state.sendEmail ? 'true' : 'false'); // Always send boolean as string for consistency
            formData.append('createDocument', state.createDocument ? 'true' : 'false'); // Always send boolean as string for consistency
            formData.append('brakeTestJobDocumentName', state.brakeTestJobDocumentName || '');

            let res = await postBreakTestDetails(portalSettings.portalSettingBrakeTestDocumentID, formData);
            if (res.success) {
                showToast(res.message);
                if (fromStep) {
                    setTimeout(() => {
                        window.top.postMessage({ type: navigateToDashboard ? 'navigate-dashboard' : 'close-modal' }, '*');
                    }, 1000);
                }
            } else {
                // let errorMessages = Object.values(res.errors).flat().join('\n');
                // showToast(errorMessages);
                showToast(res.message || 'Something went wrong');
                console.error(res);
            }
            setBtnLoader(false);
        }
    };

    const handleClose = () => {
        window.top.postMessage({ type: 'close-modal' }, '*');
    };

    return (
        <div style={{ padding: '20px' }}>
            <Grid container spacing={2}>
                {state.showCircularLoader ? (
                    <Grid item xs={12}>
                        <CircularProgress />
                    </Grid>
                ) : (
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} style={{ textAlign: 'left' }}>
                                <Grid container justifyContent="space-between" alignItems="center">
                                    <Grid item>
                                        WIP No:&nbsp; <b>{state.wipNumber || 'N/A'}</b>
                                    </Grid>
                                    <Grid item>
                                        Registration Number:&nbsp; <b>{state.registration || 'N/A'}</b>
                                    </Grid>
                                </Grid>
                            </Grid>

                            {state.brakeTestJobDocumentName ? (
                                <>
                                    <Grid item xs={12} lg={6}>
                                        <div style={{ border: '1px dashed #5e87f8', padding: '8px', height: '100%' }}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <FormLabel
                                                        component="legend"
                                                        className="mandatoryfields"
                                                        style={{ display: 'block', marginBottom: '8px', textAlign: 'left' }}
                                                    >
                                                        Declaration
                                                    </FormLabel>
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <div
                                                        dangerouslySetInnerHTML={{ __html: state.brakeTestDeclaration }}
                                                        style={{
                                                            minHeight: '200px',
                                                            maxHeight: 'calc(100vh - 540px)',
                                                            overflow: 'auto'
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <FormLabel component="legend" className="mandatoryfields">
                                                        Name
                                                    </FormLabel>
                                                    <TextBox
                                                        required
                                                        name="brakeTestSignedName"
                                                        value={state.brakeTestSignedName}
                                                        onChange={handleFieldChange}
                                                        disabled={state.brakeTestSigned}
                                                    />
                                                    <span style={styles.required}>{error['brakeTestSignedName']}</span>
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <CustomeSignPad
                                                        onChange={GetTechnicianSign}
                                                        content={
                                                            <FormLabel error>
                                                                {`Signature 
                                                                ${state.brakeTestSigned ? formatters.DateTimeFormatter(state.brakeTestSignedDate) : ''}`}
                                                            </FormLabel>
                                                        }
                                                        sign={state.brakeSignature}
                                                        name="brakeTestSignature"
                                                        clearSig={clearSig}
                                                    />

                                                    <span style={styles.required}>{error['brakeTestSignature']}</span>
                                                </Grid>

                                                {!state.brakeTestSigned && (
                                                    <Grid item xs={12} className="mandatoryfields">
                                                        <InputLabel style={{ color: state.sendEmail ? 'red' : 'black' }}>
                                                            <span>
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={handleFieldChange}
                                                                    name="sendEmail"
                                                                    checked={state.sendEmail}
                                                                />{' '}
                                                                Send Email
                                                            </span>
                                                        </InputLabel>
                                                        <TextBox type="email" onChange={handleFieldChange} name="emailsentTo" value={state.emailsentTo} />
                                                        <FormHelperText error>{state.errors.emailsentTo}</FormHelperText>
                                                    </Grid>
                                                )}

                                                <Grid item xs={12}>
                                                    {state.brakeTestSigned ? (
                                                        <SecondaryButton className="setFullWidth" onClick={handleClose} style={{ marginBottom: '5px' }}>
                                                            Cancel
                                                        </SecondaryButton>
                                                    ) : (
                                                        <SecondaryButton
                                                            className="setFullWidth"
                                                            onClick={saveDynamicFormFieldUploadDoc}
                                                            style={{ marginBottom: '5px' }}
                                                            isBtnLoader={btnLoader}
                                                            disabled={btnLoader}
                                                        >
                                                            Submit
                                                        </SecondaryButton>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </Grid>

                                    <Grid item xs={12} lg={6}>
                                        <div style={{ border: '1px dashed #5e87f8', padding: '8px', height: '100%' }}>
                                            <Grid container>
                                                <Grid item xs={12}>
                                                    <Grid container justifyContent="space-between" alignItems="center">
                                                        <Grid item>
                                                            <FormLabel component="legend" className="mandatoryfields">
                                                                Brake Test
                                                            </FormLabel>
                                                        </Grid>
                                                        {state.hasLocalFile && (
                                                            <Grid item onClick={handleRemoveImage}>
                                                                <IconButton
                                                                    title="Remove Document"
                                                                    style={{
                                                                        background: '#f50057',
                                                                        opacity: 0.3,
                                                                        color: 'white',
                                                                        height: '24px',
                                                                        width: '24px'
                                                                    }}
                                                                    color="secondary"
                                                                    onClick={() => setPageNo((curr) => curr + 1)}
                                                                >
                                                                    x
                                                                </IconButton>
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    style={{
                                                        height: `calc(100vh - ${props.HeaderRecordID ? '200px' : '150px'})`
                                                    }}
                                                >
                                                    {documentLoader ? (
                                                        <CircularProgress />
                                                    ) : (
                                                        <>
                                                            {state.hasLocalFile ? (
                                                                <ViewPdfModal pdfFileData={state.imagesFromUrl} height={'100%'} />
                                                            ) : state.imagesFromUrl.length > 0 ? (
                                                                <div style={{ height: '100%', overflow: 'auto', position: 'relative' }}>
                                                                    <img src={state.imagesFromUrl[currentPageNo]} style={{ width: '100%' }} />
                                                                    {hasPrev(currentPageNo) && (
                                                                        <div
                                                                            style={{
                                                                                left: '5px',
                                                                                top: '50%',
                                                                                transform: 'translateY(-50%)',
                                                                                position: 'absolute',
                                                                                zIndex: '99'
                                                                            }}
                                                                        >
                                                                            <IconButton
                                                                                style={{
                                                                                    background: '#f50057',
                                                                                    opacity: 0.3,
                                                                                    color: 'white',
                                                                                    height: '24px',
                                                                                    width: '24px'
                                                                                }}
                                                                                color="secondary"
                                                                                onClick={() => setPageNo((curr) => curr - 1)}
                                                                            >
                                                                                <ArrowLeft />
                                                                            </IconButton>
                                                                        </div>
                                                                    )}
                                                                    {hasNext(currentPageNo) && (
                                                                        <div
                                                                            style={{
                                                                                right: '5px',
                                                                                top: '50%',
                                                                                transform: 'translateY(-50%)',
                                                                                position: 'absolute',
                                                                                zIndex: '99'
                                                                            }}
                                                                        >
                                                                            <IconButton
                                                                                style={{
                                                                                    background: '#f50057',
                                                                                    opacity: 0.3,
                                                                                    color: 'white',
                                                                                    height: '24px',
                                                                                    width: '24px'
                                                                                }}
                                                                                color="secondary"
                                                                                onClick={() => setPageNo((curr) => curr + 1)}
                                                                            >
                                                                                <ArrowRight />
                                                                            </IconButton>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <div
                                                                    style={{
                                                                        height: '100%',
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center'
                                                                    }}
                                                                >
                                                                    <Tooltip title="Upload Document">
                                                                        <label>
                                                                            <IconButton color="secondary" component="span" style={{ padding: 0 }}>
                                                                                <Backup style={{ fontSize: '60px' }} />
                                                                                <input
                                                                                    type="file"
                                                                                    onChange={handleImage}
                                                                                    style={{ display: 'none' }}
                                                                                    accept="application/pdf"
                                                                                />
                                                                            </IconButton>
                                                                        </label>
                                                                    </Tooltip>
                                                                    <p>No brake test found</p>
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </Grid>
                                </>
                            ) : (
                                <Grid
                                    container
                                    style={{ height: `calc(100vh - ${props.HeaderRecordID ? '200px' : '150px'})` }}
                                    alignItems="flex-end"
                                    justifyContent="space-between"
                                >
                                    <Grid item xs={12}>
                                        <b>Please upload brake test document before it can be verified and signed</b>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <SecondaryButton className="setFullWidth" onClick={handleClose} style={{ marginBottom: '5px' }}>
                                            Cancel
                                        </SecondaryButton>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </div>
    );
};

export default BreakTest;
